// PDFWrapper.jsx
import React, { useRef, forwardRef, useImperativeHandle } from "react";
import generatePDF from "react-to-pdf";

const FormPDFWrapper = forwardRef(
  ({ children, fileName = "download.pdf" }, ref) => {
    const contentRef = useRef();

    useImperativeHandle(ref, () => ({
      generatePDF: () => {
        generatePDF(contentRef, {
          filename: fileName,
          page: { margin: 8, format: "a4" }, // your exact card size
          canvas: { scale: 0, useCORS: true, backgroundColor: null },
        });
      },
    }));

    return (
      // hidden clone for stable PDF output
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <div ref={contentRef}>{children}</div>
      </div>
    );
  }
);

export default FormPDFWrapper;
